import { render, staticRenderFns } from "./ContentDetailPage.vue?vue&type=template&id=4ce841ac&scoped=true"
import script from "./ContentDetailPage.vue?vue&type=script&lang=js"
export * from "./ContentDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ContentDetailPage.vue?vue&type=style&index=0&id=4ce841ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce841ac",
  null
  
)

export default component.exports